import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import cssclass from "./cssclass";
import { useNavigate } from 'react-router-dom'

//this page should replace lbrclrresponse.  Also see wptappscan


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	
const scansurl=sessionStorage.getItem("SCANSURL");	


//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});

const [wptapp, setWptapp] = useState({WPT_APP_ID:0});
const [axiofl, setAxiofl] = useState({selectedFile: null});
const [uploadfile, setUploadfile] = useState({name:""});
const [progress, setProgress] = useState({
perct:null
});

const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS Documents";	

if (location.state!=null){
	if (location.state.wptapp!=undefined)
		setWptapp(location.state.wptapp);
	
	if (location.state.TOTAL_EMPTY_FIELDS){
		const NUM=location.state.TOTAL_EMPTY_FIELDS.NUM??1;
		setTOTAL_EMPTY_FIELDS({NUM:NUM});
		}//end if
		
	
	}//end if


 },[]);



useEffect(() => {
	
const REF_NUM = wptapp.REF_NUM??"";
	
if (REF_NUM=="")
	return;

/*
rdscans,rdlatescan,rdlabourscan,rdbalrcpscan
if CHR_FIRST_SUBMITTED is empty default rdscans 
if wptapp.STATUS=="DEFERRED" || wptapp.STATUS=="DENIED" default rdlabourscan
*/
if (wptapp.CHR_FIRST_SUBMITTED=="")
	document.getElementById("rdscans").click();
else{
	if (wptapp.STATUS=="DEFERRED" || wptapp.STATUS=="DENIED")
		document.getElementById("rdlabourscan").click();
	else
		document.getElementById("rdlatescan").click();
	}//end else
	


	


 },[wptapp.REF_NUM]);


async function doFileUpload () {

 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();
const filename=uploadfile.name;
const newfileobj=new File([axiofl.selectedFile], filename);

form.append('WPT_APP_ID', wptapp.WPT_APP_ID);
form.append('REF_NUM', wptapp.REF_NUM);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('filename', filename);
form.append('file', newfileobj, newfileobj.name);//
//form.append('filename', axiofl.selectedFile.name);


setDowait({show:true});
//importingwptapp=true;
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(scansurl+'rarscans/uploadscanneddoc', form, request_config)
.then(res => afterDoFileUpload(res.data))
.catch(error => { 
		setDowait({show:false});
         showsnackbar(error+"<br/>please try logout and login again");
     });//end catch
	 
}//end function


function afterDoFileUpload(res){
	console.log('afterDoFileUpload');
	setDowait({show:false});
	setAxiofl({ selectedFile: null });
	
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	if (UPDATE_COUNT==0)
		window.alert("Database was not updated");
	else{
		setWptapp((prev)=>{
			return {...prev
			, LATE_SCAN_SIZE:res[0].LATE_SCAN_SIZE
			, LATE_SCAN_ALLOW:res[0].LATE_SCAN_ALLOW
			, LC_APPEAL_PDF_SIZE:res[0].LC_APPEAL_PDF_SIZE
			, LC_APPEAL_DATE:res[0].LC_APPEAL_DATE
			, BAL_RCP_PDF_SIZE:res[0].BAL_RCP_PDF_SIZE
			}
		})
		showsnackbar("done!");
		
		const arrFilename="scans.pdf,latescan.pdf,labourscan.pdf,balrcpscan.pdf".split(",");
		const arrRadioId="rdscans,rdlatescan,rdlabourscan,rdbalrcpscan".split(",");
		const arrFileinputId="scansfileinput,latescanfileinput,labourscanfileinput,balrcpscanfileinput".split(",");
		for (var i=0; i<arrFileinputId.length; i++){
			const currFileinputId=arrFileinputId[i];
			if (document.getElementById(currFileinputId))
				document.getElementById(currFileinputId).value='';
			
			const radioId=arrRadioId[i];
			if (document.getElementById(radioId))
				if (document.getElementById(radioId).checked==true)
					getpdf(arrFilename[i]);
			}//end for
			
		
		}//end else

}//end function

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func
	
function onFileChange(event) {

setAxiofl({ selectedFile: null });

if (event.target.files.length>1){
	document.getElementById("fileinput").value='';
	window.alert("upload only one file please");
	return;
	}
else if (event.target.files.length==0){
	document.getElementById("fileinput").value='';
	window.alert("No file was uploaded");
	return;
	}
	
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
//,.jpg,.jpeg
const lsExtension="pdf";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("fileinput").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if	

if (event.target.files.length==1){
	
/*
	if (document.getElementById('btnfileupload')){
		const btnfileupload=document.getElementById('btnfileupload');
		if (btnfileupload.classList.contains("hidden"))
			btnfileupload.remove("hidden");
		}//end if

*/	
	// Update the state
	setAxiofl({ selectedFile: event.target.files[0] });
	}//end if

}//end function




function getpdf(filename){
//pdfdoc
let mpename=wptapp.MPE_NAME??"";
mpename=mpename.replace(/[\W_]+/g," ")
const url=resturl+"rarwpform/getwptapppdfdoc?mpename="+mpename+"&filename="+filename+"&refnum="+wptapp.REF_NUM;
console.log("url: "+url);

document.getElementById("embed1").src = url;
//document.getElementById("embed1").src=src;
//getwptapppdfdoc
setUploadfile({name:filename});
const fileinputid=filename.replace(".pdf", "fileinput");
/*
if (filename=="scans.pdf")
	fileinputid="scansfileinput";
else
	fileinputid=(filename=="latescan.pdf")?"latescanfileinput":"labourscanfileinput";

*/

//disable all file inputs
const arrFileinputId="scansfileinput,latescanfileinput,labourscanfileinput,balrcpscanfileinput".split(",");
for (var i=0; i<arrFileinputId.length; i++){
	const currFileinputId=arrFileinputId[i];
	if (document.getElementById(currFileinputId))
		document.getElementById(currFileinputId).disabled=currFileinputId==fileinputid?false:true;
	}//end for

}//end func



const returnPg=(wptapp.PROCESS_AREA??"")=="Government"?"gvtform":"wptform";	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"20px"}} >
	If this application {wptapp.REF_NUM} is deferred, you can return here to upload files
	</p>
	{/*<p style={{color:"brown"}} align="center" ></p>*/}
	
	<table align='center'>
	<tbody>
	
	<tr>
	<td align='right' >Date First Submitted:</td>
	<td align='left' >{wptapp.CHR_FIRST_SUBMITTED}</td>
	</tr>
	<tr>
	<td align='right' >Employer's Name: </td>
	<td align='left' >{wptapp.MPR_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Applicant's Name: </td>
	<td align='left' >{wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}</td>
	</tr>
	<tr>
	<td align='right' >Application Status: </td>
	<td align='left' >{wptapp.WPT_STATUS}</td>
	</tr>
	<tr>
	<td align='right' >Late Scans Allowed: </td>
	<td align='left' >{wptapp.LATE_SCAN_ALLOW==0?"No":"Yes"}</td>
	</tr>
	{
	wptapp.CHR_SUBMITTED_TO_CSC!="" && 
	<tr>
	<td align='right' >Date Submitted: </td>
	<td align='left' >{wptapp.CHR_SUBMITTED_TO_CSC}</td>
	</tr>	
	}

	</tbody>
	</table>
	<div align="center" ><a href="#" target="_blank" onClick={(e)=>{ e.preventDefault(); window.open('/pdfdoc');  }}>click here</a> if you have more than one pdf files and need to merge them into one </div>

		<table align="center" className="customers" style={{width:"86%"}} >
		<thead>
		<tr>
		<th align="left" >&nbsp;&nbsp;File Upload</th>
		<th align="left" >&nbsp;&nbsp;Click the correct File Below</th>
		<th align="left" >&nbsp;&nbsp;When Required</th>
		<th align="left" >&nbsp;&nbsp;When Allowed</th>
		</tr>
		</thead>
		<tbody>
		<tr>
		<td align="left" >{wptapp.STATUS=="NOTSUBMIT" && <input type='file' disabled id="scansfileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}} />}</td>
		<td align="left" ><input type='radio' name='rd_scans' id='rdscans' onClick={(e)=>{getpdf("scans.pdf");}} /><label htmlFor='rdscans' className='hand' > Scanned Documents</label></td>
		<td align="left" >Before Submitting Application</td>
		<td align="left" >Only Before Submitting Application</td>
		</tr>
		<tr>
		<td align="left" >{wptapp.LATE_SCAN_ALLOW=="1" && <input type='file' disabled id="latescanfileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}} />}</td>
		<td align="left" ><input type='radio' name='rd_scans'  id='rdlatescan' onClick={(e)=>{getpdf("latescan.pdf");}} /><label htmlFor='rdlatescan' className='hand' > Late Scanned Documents</label></td>
		<td align="left" >If your forgot something or the application is deferred before Labour Clearance</td>
		<td align="left" >Only After Submitting Application.  Once only</td>
		</tr>
		
		<tr>
		<td align="left" >{(wptapp.STATUS=="DEFERRED" || wptapp.STATUS=="DENIED") && <input type='file' disabled id="labourscanfileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}} />}</td>
		<td align="left" ><input type='radio' name='rd_scans'  id='rdlabourscan' onClick={(e)=>{getpdf("labourscan.pdf");}} /><label htmlFor='rdlabourscan' className='hand' > Deferred Labour Clearance</label></td>
		<td align="left" >If Labour Clearance is deferred</td>
		<td align="left" >Only After Labour Clerance is Deferred</td>
		</tr>

		<tr>
		<td align="left" >{wptapp.STATUS=="APPROVED" && <input type='file' disabled id="balrcpscanfileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}} />}</td>
		<td align="left" ><input type='radio' name='rd_scans'  id='rdbalrcpscan' onClick={(e)=>{getpdf("balrcpscan.pdf");}} /><label htmlFor='rdbalrcpscan' className='hand' > Paid Balance Receipts</label></td>
		<td align="left" >Optionally you can upload copy of paid balance receipts</td>
		<td align="left" >Only After Labour Clerance is Approved</td>
		</tr>


		</tbody>
		</table>


		<table align="center" width="75%" >
		<tbody>
		{axiofl.selectedFile==null &&
			<tr>
			<td align="center" >
				<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/"+returnPg, {state:{WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:"J"}});  }}  ><img src="img/return.png" border="0" /> return to application</a>
			</td>
			<td align="center" >
				verify your pdf documents below,<br/>then click proceed or upload new files if needed
			</td>
			<td align="center" >
				{
				wptapp.STATUS=="NOTSUBMIT" && (TOTAL_EMPTY_FIELDS.NUM==0 || wptapp.CHR_FIRST_SUBMITTED!="") &&
				<button className="button" onClick={(e)=>{navigate("/wpsummary", {state:{wptapp:wptapp}});  }} >proceed to submit application</button>
				}
				
				{
				//not sure about the below.  probably should not have a proceed button for DEFERRED
				(wptapp.STATUS=="DEFERRED" || wptapp.STATUS=="DENIED") && wptapp.LATE_SCAN_ALLOW==0 &&
				<button className="button" onClick={(e)=>{navigate("/wpsummary", {state:{wptapp:wptapp}});  }} >proceed to submit application</button>
				}
				
			</td>
			</tr>
		}
		{axiofl.selectedFile!=null && 
			<tr>
			<td align="center" >
			<button onClick={doFileUpload} className='button' id='btnfileupload' >upload pdf file</button>
			</td>
			</tr>
		}

		</tbody>
		</table>
		
		<div align="center">
		<embed id="embed1"
			/*src="https://customsprem.gov.tc/webuploads/currdoc/Notice%20Of%20Auction%20-%20Providenciales%20Auction%20List%202021.pdf#toolbar=0&navpanes=0&scrollbar=0"*/
			src=""
			type="application/pdf"
			frameBorder="0"
			scrolling="auto"
			height="800"
			width="95%"
			
		></embed>
		</div>
					


{/*
	<tr>
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptform", {state:{WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:"J"}});  }}  ><img src="img/return.png" border="0" /> return to application</a></td>

	<td align='left' style={{paddingLeft:"18px"}} >
		{wptapp.LATE_SCAN_ALLOW=="1" && <input type="file" id="fileinput" accept=".pdf" onChange={(e)=>{onFileChange(e);}}   />}
		&nbsp;&nbsp;
		
		
		{dowait.show==true && <><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</>}
		{
		dowait.show==false && axiofl.selectedFile!=null && 
		<button onClick={doFileUpload} className='button' id='btnfileupload' >upload file</button>
		}		
			
	</td>
	</tr>

	<tr>
	<td align='center' colSpan='2' >
		{wptapp.REF_NUM!=undefined && <>
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		<br/>close-up head shot
		</>
		}
		</td>
	</tr>

*/}	



<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;